<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Company Stocks'
                    : 'Deleted Company Stocks'
                "
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  @click="showCreateDialog = true"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search product name... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="500"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Product Name</th>
                      <th class="text-left">Color</th>
                      <th class="text-left">Size</th>
                      <!-- <th class="text-left">Price</th> -->
                      <th class="text-left">Quantity</th>
                      <th class="text-left">Created At</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="companyStocks.length != 0">
                    <tr v-for="(stock, i) in companyStocks" :key="`stock${i}`">
                      <td style="min-width: 85px">
                        {{ (page - 1) * rowsPerPage + i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="stock.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Stock is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="stock.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Stock is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ stock.variant?.product?.name || "" }}</td>
                      <td>{{ stock.variant?.color || "" }}</td>
                      <td>{{ stock.variant?.size || "" }}</td>
                      <!-- <td>₹{{ stock.variant?.price || "0.00" }}</td> -->
                      <td>{{ stock.quantity || "0" }}</td>
                      <td>
                        {{ stock.created_at | niceDateTime }}
                      </td>

                      <td class="text-right">
                        <template v-if="stock.is_deleted != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="askDelete(stock)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this stock</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="info"
                                @click="openView(stock)"
                              >
                                <v-icon dark> mdi-eye </v-icon>
                              </v-btn>
                            </template>
                            <span>View this stock</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                @click="openEditDialog(stock)"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this stock</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(stock.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this stock</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination
                v-model="page"
                :length="paginationLength"
                @input="getData"
              >
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_stock" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Success!</h1>
                      <br />
                      <h3>Company Stock deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_stock = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_stock" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Success!</h1>
                      <br />
                      <h3>Company Stock restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_stock = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Delete confirmation -->
    <ConfirmationDialog
      :show.sync="deleteDialog"
      title="Delete Company Stock"
      message="This action cannot be undone."
      icon="mdi-delete"
      color="error"
      :loading="delete_stock"
      @confirm="Delete_this(pendingDeleteId)"
    >
      <template v-slot:details>
        <v-alert v-if="pendingDeleteStock" outlined color="error" class="mt-3 mb-0" dense>
          <div class="d-flex align-center">
            <v-avatar color="error" size="36" class="mr-3">
              <v-icon color="white" size="18">mdi-warehouse</v-icon>
            </v-avatar>
            <div>
              <div class="font-weight-bold">
                {{ pendingDeleteStock.variant?.product?.name || "Unknown product" }}
              </div>
              <div class="text-caption grey--text text--darken-1">
                {{ formatVariant(pendingDeleteStock.variant) || "No variant details" }}
                <span> · {{ pendingDeleteStock.quantity || 0 }} in stock</span>
              </div>
            </div>
          </div>
        </v-alert>
      </template>
    </ConfirmationDialog>

    <!-- Add Company Stock -->
    <AppDialog
      :show.sync="showCreateDialog"
      max-width="900"
      persistent
      icon="mdi-warehouse"
      title="Add Company Stock"
      subtitle="Add stock for an existing product variant"
    >
      <CompanyStockCreatePage
        v-if="showCreateDialog"
        embedded
        @created="onStockCreated"
        @close="showCreateDialog = false"
      />
    </AppDialog>

    <!-- Edit Company Stock -->
    <AppDialog
      :show.sync="showEditDialog"
      max-width="900"
      persistent
      icon="mdi-warehouse"
      title="Edit Company Stock"
      subtitle="Adjust or set this variant's stock"
    >
      <CompanyStockEditPage
        v-if="showEditDialog"
        embedded
        :stock-id="editingId"
        @saved="onStockUpdated"
        @close="showEditDialog = false"
      />
    </AppDialog>

    <!-- View Company Stock -->
    <AppDialog
      :show.sync="showViewDialog"
      max-width="600"
      icon="mdi-warehouse"
      :title="viewingStock && viewingStock.variant && viewingStock.variant.product ? viewingStock.variant.product.name : 'Company Stock'"
      :subtitle="viewingStock ? formatVariant(viewingStock.variant) : ''"
      :status-text="viewingStock ? (viewingStock.is_active ? 'Active' : 'Inactive') : ''"
      :status-color="viewingStock && viewingStock.is_active ? 'success' : 'error'"
    >
      <div class="pa-2" v-if="viewingStock">
        <v-row dense>
          <v-col cols="6">
            <AppInfoCard icon="mdi-cube-outline" label="Quantity" :value="String(viewingStock.quantity || 0)" />
          </v-col>
          <v-col cols="6">
            <AppInfoCard icon="mdi-currency-inr" label="Price" :value="viewingStock.variant && viewingStock.variant.price ? `₹${viewingStock.variant.price}` : 'N/A'" />
          </v-col>
          <v-col cols="6">
            <AppInfoCard icon="mdi-palette" label="Color" :value="viewingStock.variant ? viewingStock.variant.color || 'N/A' : 'N/A'" />
          </v-col>
          <v-col cols="6">
            <AppInfoCard icon="mdi-tape-measure" label="Size" :value="viewingStock.variant ? viewingStock.variant.size || 'N/A' : 'N/A'" />
          </v-col>
          <v-col cols="12">
            <AppInfoCard icon="mdi-calendar" label="Created At" :value="$options.filters.niceDateTime(viewingStock.created_at)" />
          </v-col>
        </v-row>
      </div>
    </AppDialog>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import AppDialog from "@/components/AppDialog.vue";
import AppInfoCard from "@/components/AppInfoCard.vue";
import CompanyStockCreatePage from "./create.vue";
import CompanyStockEditPage from "./id.vue";

export default {
  name: "CompanyStocksIndexPage",
  components: { ConfirmationDialog, AppDialog, AppInfoCard, CompanyStockCreatePage, CompanyStockEditPage },
  data() {
    return {
      companyStocks: [],
      showViewDialog: false,
      viewingStock: null,
      showCreateDialog: false,
      showEditDialog: false,
      editingId: null,
      deleteDialog: false,
      pendingDeleteId: null,
      pendingDeleteStock: null,
      delete_stock: false,
      filter: {
        search_keyword: "",
        is_active: "",
      },
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      isLoading: false,
      is_deleted_stock: false,
      is_restored_stock: false,
      page: 1,
      paginationLength: 0,
    };
  },
  created() {
    this.getData();
  },
  watch: {
    "$route.query.deleted": {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active =
        this.filter.is_active !== null ? this.filter.is_active : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword +
        "&is_active=" +
        this.filter.is_active;

      await axios
        .get(`company_stocks?${query}`)
        .then((response) => {
          this.companyStocks = response.data.data;
          this.paginationLength = Math.ceil(
            response.data.count / this.rowsPerPage,
          );
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    openView(stock) {
      this.viewingStock = stock;
      this.showViewDialog = true;
    },
    formatVariant(variant) {
      if (!variant) return "";
      const parts = [];
      if (variant.color) parts.push(variant.color);
      if (variant.size) parts.push(variant.size);
      return parts.join(" - ");
    },
    askDelete(stock) {
      this.pendingDeleteId = stock.id;
      this.pendingDeleteStock = stock;
      this.deleteDialog = true;
    },
    async Delete_this(id) {
      this.delete_stock = true;
      await axios
        .post(`/company_stocks/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_stock = true;
          this.deleteDialog = false;
          this.pendingDeleteStock = null;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.delete_stock = false;
        });
    },
    onStockCreated() {
      this.showCreateDialog = false;
      this.page = 1;
      this.getData();
    },
    openEditDialog(stock) {
      this.editingId = this.encryptIt(stock.id);
      this.showEditDialog = true;
    },
    onStockUpdated() {
      this.showEditDialog = false;
      this.getData();
    },
    async Restore_this(id) {
      await axios
        .post(`/company_stocks/restore/${id}`)
        .then(() => {
          this.is_restored_stock = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.striped-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
